import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/pages-container/CoffretEssentialPlus.tsx");
